/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: NonNullable<unknown>, source: NonNullable<unknown> }} Duplicate_To_Another_PlaceInputs */



/**
* | resource | output |
* | --- | --- |
* | "airHandlerUnit" | "Duplicate days from \"{source}\" to other units" |
* | "network" | "Duplicate days from network \"{source}\" to other networks" |
* | "room" | "Duplicate days from room \"{source}\" to other rooms" |
* | * | "Duplicate days from room \"{source}\" to other rooms" |
*
* @param {Duplicate_To_Another_PlaceInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_to_another_place = /** @type {((inputs: Duplicate_To_Another_PlaceInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_To_Another_PlaceInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Duplicate days from "${i?.source}" to other units`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Duplicate days from network "${i?.source}" to other networks`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Duplicate days from room "${i?.source}" to other rooms`);
		return /** @type {LocalizedString} */ (`Duplicate days from room "${i?.source}" to other rooms`)
	}
	{
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Dupliquer des jours de “${i?.source}” vers d'autres équipements`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Dupliquer des jours du réseau “${i?.source}” vers d'autres réseaux`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Dupliquer des jours de la pièce “${i?.source}” vers d'autres pièces`);
		return /** @type {LocalizedString} */ (`Dupliquer des jours de la pièce “${i?.source}” vers d'autres pièces`)
	}
});